import { useEffect, useState } from "react";
import { Button, Divider, Modal, ScrollArea } from "@mantine/core";

import FormNotification from "./FormNotification";
import FormFile from "./FormFile/FormFile";
import TableSubmissions from "./TableSubmissions";

import { useFirmwareMultipartSubmit, useFirmwares } from "../../hooks/useFirmware";
import HeaderTitle from "components/ui/Header/HeaderTitle";

import BannerTop from "./BannerTop";
import BannerBottom from "./BannerBottom";
const Firmware: React.FC = () => {
  document.title = "Dante Firmware Manager";

  const [isNotificationModal, setIsNotificationModal] =
    useState<boolean>(false);

  const [isFileModal, setIsFileModal] = useState<boolean>(false);
  const [fileUploadProgress, setFileUploadProgress] = useState<number>(0);
  const [isNonDntSubmitting, setIsNonDntSubmitting] = useState<boolean>(false);

  const {
    data: firmwareData,
    isLoading: isFirmwareDataLoading,
    refetch: firmwareDataRefetch,
  } = useFirmwares();

  const {
    mutate: firmwareNonDntSubmitMutate,
    isSuccess: isFirmwareNonDntSubmitSuccess,
    isError: isFirmwareNonDntSubmitError,
    reset: resetFirmwareNonDntSubmit,
  } = useFirmwareMultipartSubmit(setFileUploadProgress);

  const {
    mutate: firmwareDntInitiateSubmitMutate,
    data: firmwareDntInitiateSubmitData,
    isSuccess: isFirmwareDntInitiateSubmitSuccess,
    isError: isFirmwareDntInitiateSubmitError,
    reset: resetFirmwareDntInitiateSubmit,
  } = useFirmwareMultipartSubmit(setFileUploadProgress);

  useEffect(() => {
    if (isFirmwareNonDntSubmitSuccess || isFirmwareNonDntSubmitError) {
      setIsNonDntSubmitting(false);
      setIsFileModal(false);
    }
  }, [isFirmwareNonDntSubmitSuccess, isFirmwareNonDntSubmitError]);

  return (
    <>
      <HeaderTitle title="Dante Firmware Manager">
        <Button onClick={() => setIsNotificationModal(true)}>
          Upload Firmware URL
        </Button>
        <Button
          onClick={() => setIsFileModal(true)}
          disabled={isNonDntSubmitting}
        >
          {isNonDntSubmitting
            ? fileUploadProgress !== 100
              ? `Uploading (${fileUploadProgress}%)`
              : `Submitting...`
            : "Upload Firmware File"}
        </Button>
      </HeaderTitle>
      <BannerTop />
      <TableSubmissions data={firmwareData} isLoading={isFirmwareDataLoading} />
      <Divider my="md" />
      <BannerBottom />
      <Modal
        size="lg"
        scrollAreaComponent={ScrollArea.Autosize}
        title="Upload Firmware URL"
        opened={isNotificationModal}
        onClose={() => setIsNotificationModal(false)}
        centered
      >
        <FormNotification
          firmwareDataRefetch={firmwareDataRefetch}
          onClose={() => setIsNotificationModal(false)}
        />
      </Modal>
      <Modal
        size="lg"
        scrollAreaComponent={ScrollArea.Autosize}
        title="Upload Firmware File"
        opened={isFileModal}
        onClose={() => {
          setIsFileModal(false);
          resetFirmwareDntInitiateSubmit();
          resetFirmwareNonDntSubmit();
        }}
        centered
      >
        <FormFile
          firmwareDataRefetch={firmwareDataRefetch}
          onClose={() => {
            setIsFileModal(false);
            resetFirmwareDntInitiateSubmit();
            resetFirmwareNonDntSubmit();
          }}
          uploadProgress={fileUploadProgress}
          setUploadProgress={setFileUploadProgress}
          isNonDntSubmitting={isNonDntSubmitting}
          setIsNonDntSubmitting={setIsNonDntSubmitting}
          firmwareNonDntSubmitMutate={firmwareNonDntSubmitMutate}
          isFirmwareNonDntSubmitSuccess={isFirmwareNonDntSubmitSuccess}
          firmwareDntInitiateSubmitData={firmwareDntInitiateSubmitData}
          firmwareDntInitiateSubmitMutate={firmwareDntInitiateSubmitMutate}
          isFirmwareDntInitiateSubmitSuccess={isFirmwareDntInitiateSubmitSuccess}
          isFirmwareDntInitiateSubmitError={isFirmwareDntInitiateSubmitError}
        />
      </Modal>
    </>
  );
};

export default Firmware;
